import Vue from 'vue'
import Vuex from 'vuex'

import user from './module/user'
import app from './module/app'

import dataNull from '@/assets/images/dataNullImg.png'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    toPathName:'index',
    dataNullImg:dataNull
  },
  getters:{
    //
  },
  mutations: {
    //
  },
  actions: {
    //
  },
  modules: {
    user,
    app
  }


})



// WEBPACK FOOTER //
// ./src/store/index.js